import React from 'react';
import { Link, useI18next, useTranslation } from '../../plugins/i18next/ea-react-i18next';


const defaultLanguage: string = process.env.GATSBY_LANGUAGES_DEFAULTLANGUAGE || "en";

export const LanguageSwitch: React.FC<{ selectedMenuPoint?: string, toggleSubMenu?: (id: string) => void }> = (props) => {
    const { toggleSubMenu, selectedMenuPoint } = props;
    const { languages, originalPath, i18n, changeLanguage } = useI18next();
    const { t } = useTranslation("", { keyPrefix: 'app.languageswitch' });

    const handleSetChange = (e: React.MouseEvent<HTMLAnchorElement>, lang: string) => {
        e.preventDefault();
        changeLanguage(lang);
        if (originalPath.indexOf("/success-stories/") != -1) {
            const redirectPath = "success-stories";
            const pathLang = lang == defaultLanguage ? "" : `/${lang}`
            window.location.href = `${pathLang}/${redirectPath}`;
        }
    }

    if (languages.length <= 1)
        return <React.Fragment />

    const currentLanguage = i18n.language;

    return <li className="nav-item" key='defaultLang'>
        <Link to={originalPath} className="nav-link" onClick={e => { e.preventDefault(); toggleSubMenu && toggleSubMenu("lang") }}>
            {t(`languages.${currentLanguage}`)} <i className='bx bx-chevron-down'></i>
        </Link>
        <ul className={`dropdown-menu ${selectedMenuPoint === "lang" ? "show" : ""}`}>
            {languages.map((lang) => {
                return <li className="nav-item" key={lang}>
                    <Link key={lang} to={originalPath} className={`nav-link ${lang === currentLanguage ? 'active' : ''}`} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleSetChange(e, lang)} >
                        {t(`languages.${lang}`)}
                    </Link>
                </li>
            })}
        </ul>
    </li>



};